import template from './monthly-income.jade';

export default angular
    .module('cian.addForm.monthlyIncome', [])
    .directive('cianAfPriceAndDealTermsMonthlyIncome', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: ['$scope', function($scope) {
            this.ad.monthlyIncome = this.ad.monthlyIncome || {};
            $scope.$watch(() => angular.isObject(this.ad.bargainTerms) && this.ad.bargainTerms.currency, currency => {
                if (!currency) {
                    return;
                }

                this.ad.monthlyIncome.currency = currency;
            });
        }],
        controllerAs: 'monthlyIncome',
        template,
    }))
    .name;
